function getISOStringWithTimezoneOffset(d) {
	const date = new Date(d);
	if (date instanceof Date && !isNaN(date.valueOf())) {
		date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
		return date.toISOString();
	}
	return "";
}

export function getDatetime(d) {
	const str = getISOStringWithTimezoneOffset(d);
	return str ? str.slice(0, 16) : "";
}

export function getDate(d) {
	const str = getISOStringWithTimezoneOffset(d);
	return str ? str.slice(0, 10) : "";
}

export function getTime(d) {
	const str = getISOStringWithTimezoneOffset(d);
	return str ? str.slice(11, 16) : "";
}
